var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85714 1V3.85714L7.42857 4.57143L5.28571 2.42857L2.42857 5.28571L4.57143 7.42857L3.85714 8.85714H1V13.1429H3.85714L4.57143 14.5714L2.42857 16.7143L5.28571 19.5714L7.42857 17.4286L8.85714 18.1429V21H13.1429V18.1429L14.5714 17.4286L16.7143 19.5714L19.5714 16.7143L17.4286 14.5714L18.1429 13.1429H21V8.85714H18.1429L17.4286 7.42857L19.5714 5.28571L16.7143 2.42857L14.5714 4.57143L13.1429 3.85714V1H8.85714Z",
    stroke: "#26303E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 13.8571C12.5777 13.8571 13.8569 12.5779 13.8569 11C13.8569 9.42201 12.5777 8.14282 10.9997 8.14282C9.42176 8.14282 8.14258 9.42201 8.14258 11C8.14258 12.5779 9.42176 13.8571 10.9997 13.8571Z",
    stroke: "#26303E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.417bfcff.svg";
export { ForwardRef as ReactComponent };